import { RegimeTributarioEnum } from "@/features/contabil/@types/types";
import CNPJ from "./CNPJ";
import { ITiposDiagnostico } from "@/features/contabil/services/shared/gateways/Diagnostico";

type EmpresaData = {
  readonly id: string;
  readonly nomeFantasia: string | null;
  readonly razaoSocial: string | null;
  readonly regimeTributario: RegimeTributarioEnum;
  readonly cnpj: CNPJ;
  readonly updatedAt: string | null;
  readonly diagnosticos?: Partial<ITiposDiagnostico>;
  readonly podeVisualizarVisaoEstrategica: boolean;
};

export default class Empresa {
  id: string;
  nomeFantasia: string | null;
  razaoSocial: string | null;
  regimeTributario: RegimeTributarioEnum;
  podeVisualizarVisaoEstrategica: boolean;
  cnpj: CNPJ;
  updatedAt: string | null;
  diagnosticos?: Partial<ITiposDiagnostico>;

  private constructor(params: EmpresaData) {
    this.id = params.id;
    this.nomeFantasia = params.nomeFantasia;
    this.razaoSocial = params.razaoSocial;
    this.regimeTributario = params.regimeTributario;
    this.cnpj = params.cnpj;
    this.updatedAt = params.updatedAt;
    this.diagnosticos = params.diagnosticos;
    this.podeVisualizarVisaoEstrategica = params.podeVisualizarVisaoEstrategica;

    Object.freeze(this);
  }

  static create(params: EmpresaData): Empresa {
    return new Empresa(params);
  }

  getProps(): EmpresaData {
    return this;
  }

  getCNPJ(): CNPJ {
    return this.cnpj;
  }

  getDiagnosticos() {
    return this.diagnosticos;
  }

  getCNPJMask(): string {
    return this.cnpj.mask();
  }
}
